export default __webpack_public_path__ + "static/media/Raleway-SemiBold.bd43d947.ttf";